import { Component } from '@angular/core';
import { CardComponent } from '../../components/card/card.component';
import { RibbonComponent } from '../../components/ribbon/ribbon.component';
import { LinkComponent } from '../../components/link/link.component';
import { CardTitleComponent } from '../../components/card-title/card-title.component';
import { FeedbackCardComponent } from '../../components/feedback-card/feedback-card.component';
import { stepData } from './content';
import { StepsComponent } from '../../components/steps/steps.component';

@Component({
  selector: 'app-scheduling-page',
  imports: [CardComponent, RibbonComponent, LinkComponent, CardTitleComponent, FeedbackCardComponent, StepsComponent],
  templateUrl: './scheduling-page.component.html',
  styleUrl: './scheduling-page.component.css',
})
export class SchedulingPageComponent {
  protected steps = stepData;

  goToFeedback() {
    const location = window.location.href;
    return location.includes('#') ? location : location + '#feedback';
  }
}
